import { defineStore } from 'pinia';

export const useCurrenciesStore = defineStore('currencies', {
    state: () => ({
        rates: {
            'rub': {
                'usd': 0.013,
                'eur': 0.011
            },
            'usd': {
                'rub': 78,
                'eur': 0.86
            },
            'eur': {
                'rub': 91.25,
                'usd': 1.17
            }
        }
    }),

    getters: {
        getRates: state => state.rates
    }
})